import { ChevronRight } from "lucide-react";
import { JsonLd } from "@/components/JsonLd";
import { breadcrumbListJsonLd, type BreadcrumbItem } from "@/lib/schema";

type Props = {
  items: BreadcrumbItem[];
};

export function Breadcrumbs({ items }: Props) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="border-b border-border/60 bg-background">
      <div className="mx-auto flex max-w-7xl items-center px-4 py-3 lg:px-8">
        <ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={`${item.path}-${item.name}`} className="inline-flex items-center gap-1.5">
                {index > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
                {isLast ? (
                  <span className="font-display tracking-wider text-foreground" aria-current="page">
                    {item.name}
                  </span>
                ) : (
                  <a
                    href={item.path}
                    className="font-display tracking-wider hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                  >
                    {item.name}
                  </a>
                )}
              </li>
            );
          })}
        </ol>
      </div>
      <JsonLd data={breadcrumbListJsonLd(items)} />
    </nav>
  );
}
